export interface TestimonialType {
  id: number;
  name: string;
  location: string;
  rating: number;
  text: string;
  avatar: string;
}

export const testimonials: TestimonialType[] = [
  {
    id: 1,
    name: "Мария Иванова",
    location: "София, кв. Лозенец",
    rating: 5,
    text: "Изключително съм доволна от ремонта на апартамента ми. Екипът на V&M Group работи професионално, спази сроковете и резултатът надхвърли очакванията ми. Препоръчвам ги горещо!",
    avatar: "/quote-icon.svg"
  },
  {
    id: 2,
    name: "Георги Петров",
    location: "София, кв. Младост",
    rating: 5,
    text: "Втори път работя с екипа на V&M Group и отново съм впечатлен от тяхната точност и качество. Ремонтът на банята ми е перфектен, всичко е изпълнено точно както го искахме.",
    avatar: "/quote-icon.svg"
  },
  {
    id: 3,
    name: "Елена Димитрова",
    location: "София, кв. Изток",
    rating: 4.5,
    text: "Цялостният ремонт на дома ни беше извършен изключително професионално. Майсторите бяха коректни, работеха чисто и спазиха всички уговорки. Благодарим за страхотната работа!",
    avatar: "/quote-icon.svg"
  },
  {
    id: 4,
    name: "Александър Николов",
    location: "София, Бизнес Парк",
    rating: 5,
    text: "Ремонтираха офиса ни в много кратки срокове и с високо качество. Комуникацията беше отлична, а цената - напълно справедлива за извършената работа. Ще ги търсим отново!",
    avatar: "/quote-icon.svg"
  }
];
